import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestResultFormFont from './TestResultFormFont'
import TestResultFormStyle from './TestResultFormStyle'
import type { TestResultBrandForms, TestResultFormBrandType } from './testResultTypes'

const FORM_MAP: TestResultBrandForms = {
  [BrandFormEnum.STYLE]: TestResultFormStyle,
  ...TestResultFormFont,
}

const AccordionFormBrand: TestResultFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(AccordionFormBrand) as typeof AccordionFormBrand
